import {Component, inject, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {CheckboxComponent} from '../../../../../shared/form/checkbox/checkbox.component';
import {
  VerificationWizardStorageService
} from '../../../../../@core/services/verification-wizard/verification-wizard-storage.service';
import {WizardStepComponent} from '../../wizard-step-component.interface';
import {NameStepData} from '../name-step/name-step.component';
import {AddressStepData} from '../address-step/address-step.component';
import {EmailStepData} from '../email-step/email-step.component';
import {SchoolDataInfoDto} from '../../../../../models/student-ticket/list-view/SchoolDataInfoDto';
import {GeschwisterStepData} from '../geschwister-step/geschwister-step.component';
import {StudentTicketMandateHolderDto} from '../../../../../models/student-ticket/payment/StudentTicketMandateHolderDto';
import {LandPipe} from '../../../../../shared/pipes/land.pipe';
import {DatePipe} from '@angular/common';

export interface SummaryStepData {
  confirmed: boolean;
}

interface SummaryStepForm {
  confirmed: FormControl<boolean>;
}

@Component({
  selector: 'app-summary-step',
  standalone: true,
  imports: [TranslatePipe, ReactiveFormsModule, CheckboxComponent, LandPipe, DatePipe],
  templateUrl: './summary-step.component.html',
  styleUrl: './summary-step.component.scss',
})
export class SummaryStepComponent implements OnInit, WizardStepComponent {

  @Input() ticketId: string;
  @Input() visibleStepIds: string[] = [];

  protected form: FormGroup<SummaryStepForm> = new FormGroup<SummaryStepForm>({
    confirmed: new FormControl(false, {nonNullable: true, validators: [Validators.requiredTrue]}),
  });

  protected nameData: NameStepData | null;
  protected addressData: AddressStepData | null;
  protected emailData: EmailStepData | null;
  protected schoolData: SchoolDataInfoDto | null;
  protected geschwisterData: GeschwisterStepData | null;
  protected paymentData: StudentTicketMandateHolderDto | null;

  private readonly storageService = inject(VerificationWizardStorageService);

  async ngOnInit(): Promise<void> {
    const all = await this.storageService.getAllStepData(this.ticketId);
    this.nameData = (all['name'] as NameStepData) ?? null;
    this.addressData = (all['address'] as AddressStepData) ?? null;
    this.emailData = (all['email'] as EmailStepData) ?? null;
    this.schoolData = (all['school'] as SchoolDataInfoDto) ?? null;
    this.geschwisterData = (all['geschwister'] as GeschwisterStepData) ?? null;
    this.paymentData = (all['payment'] as StudentTicketMandateHolderDto) ?? null;
  }

  isStepVisible(stepId: string): boolean {
    return this.visibleStepIds.includes(stepId);
  }

  get selectedGeschwisterCount(): number {
    if (!this.geschwisterData) return 0;
    return [
      this.geschwisterData.geschwisterkind1Id,
      this.geschwisterData.geschwisterkind2Id,
      this.geschwisterData.geschwisterkind3Id,
      this.geschwisterData.geschwisterkind4Id,
      this.geschwisterData.geschwisterkind5Id,
    ].filter(id => id != null).length;
  }

  isValid(): boolean {
    return this.form.valid;
  }

  getValue(): SummaryStepData {
    return this.form.getRawValue();
  }
}
